export default "__VITE_ASSET__CaCSEgGm__"